import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as UserActions from '../../actions/users';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { RootState } from '../../reducers';
import { UserData } from '../../models/User';
import Register from './register';
import ForgotPassword from '../Common/ForgotPassword';

export namespace LoginTeacher {
	export interface Props extends RouteComponentProps<void> {
		userActions: typeof UserActions;
		user: UserData;
	}

	export interface State {
		register: boolean;
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export default class LoginTeacher extends React.Component<LoginTeacher.Props, LoginTeacher.State> {

	username: HTMLInputElement;
	password: HTMLInputElement;

	static contextTypes = {
		router: PropTypes.func.isRequired
	}

	constructor(props: LoginTeacher.Props) {
		super(props);
		this.loginUser = this.loginUser.bind(this);
		this.toggleRegistration = this.toggleRegistration.bind(this);

		this.state = { register: false };
	}

	loginUser(e: any) {
		e.preventDefault();

		// No longer removing the student login

		const { userActions } = this.props;
		const userData: UserData = {
			_id: '',
			firstname: '',
			lastname: '',
			username: this.username.value,
			password: this.password.value,
			school: ''
		};
		userActions.loginUser(userData);
	}

	toggleRegistration(e: any) {
		e.preventDefault();
		this.setState({ register: !this.state.register });
	}

	componentDidUpdate() {
		const { user } = this.props;
		console.log("COMPONENT DID UPDATE ", user);
		if (user._id)
			this.context.router.history.push("/groups");
	}

	render() {
		const { userActions } = this.props;
		const content = (() => {
			if (this.state.register) {
				return (<Register userActions={userActions} toggleRegistration={this.toggleRegistration} />);
			} else {
				return (<div>
					<div className="am_mainLogoContainer">
						<img className="margin30 am_mainLogo" src="/images/Arviointimaa-logo.png" />
					</div>
					<h3 className="am_title text-center margin30">Opettajan hallintapaneeli</h3>
					<div className="jumbotron am_teachercontainer col-6 offset-3 am_shadow">
						<form className="form-group" id="am_login" onSubmit={this.loginUser}>
							<input ref={(input) => this.username = input} className="col-12 form-control" placeholder="Käyttäjätunnus" required={true} />
							<input ref={(input) => this.password = input} className="col-12 form-control" placeholder="Salasana" type="password" required={true} />
							<button type="submit" className="col-12 btn form-control am_green-button am_shadow">KIRJAUDU</button>
							<ForgotPassword />
							<button onClick={this.toggleRegistration} className="col-12 form-control am_darkblue-button am_shadow">LUO UUSI TUNNUS...</button>
						</form>
					</div>
				</div>);
			}
		})();

		console.log(content);
		return (
			<div>
				{content}
			</div>
		);
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		userActions: bindActionCreators(UserActions as {}, dispatch)
	};
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/LoginTeacher/index.tsx